/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type RenderDesignerContactEmailInput = {
    readonly message?: string | null;
    readonly recipientEmails: ReadonlyArray<string | null>;
    readonly senderEmail: string;
    readonly senderName: string;
    readonly clientMutationId?: string | null;
};
export type RenderDesignerContactEmailMutationVariables = {
    readonly input: RenderDesignerContactEmailInput;
};
export type RenderDesignerContactEmailMutationResponse = {
    readonly renderDesignerContactEmail: {
        readonly clientMutationId: string | null;
    } | null;
};
export type RenderDesignerContactEmailMutation = {
    readonly response: RenderDesignerContactEmailMutationResponse;
    readonly variables: RenderDesignerContactEmailMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "RenderDesignerContactEmailInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "renderDesignerContactEmail",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "RenderDesignerContactEmailPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "clientMutationId",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "RenderDesignerContactEmailMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "RenderDesignerContactEmailMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "RenderDesignerContactEmailMutation",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/RenderDesignerContactEmailMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '17db93465f406d18214842de27dade5f';
export default node;
